<!-- 
    电话薄
    jay 2020-01-02
 -->
<template>
  <div>
    <Breadcrumb separator=">">
      <BreadcrumbItem to="/">{{ $t("common.eepay") }}</BreadcrumbItem>
      <BreadcrumbItem>{{ $t("recharge.viewFavoriteNumber") }}</BreadcrumbItem>
    </Breadcrumb>
    <div class="phone-wrap">
      <div class="search-wrapper">
        <Input
          prefix="ios-search"
          v-model="phone"
          :placeholder="$t('common.enterMobile')"
        />
        <Button type="primary" @click="searchNum">
          {{ $t("common.search") }}
        </Button>
        <Button type="primary" @click="addBtnFun">
          {{ $t("recharge.newNumber") }}
        </Button>
        <Button type="primary" @click="tagItemPop = true">
          {{ $t("recharge.labelManagement") }}
        </Button>
      </div>
      <div class="tag-wrapper">
        <Tabs v-model="selectIndex" @on-click="changeTab">
          <TabPane
            :label="item.tag_name"
            v-for="(item, index) in tagList"
            :key="index"
          >
            <p class="noData" v-if="showList.length == 0">
              {{ $t("recharge.noMobileNumber") }}
            </p>
            <div
              class="tel-info"
              v-else
              v-for="(tel, telIndex) in showList"
              :key="telIndex"
            >
              <span class="tel-name">{{
                tel.name == ""
                  ? (tel.mobile + "").replace(
                      /(0?\d{4})(\d{3})(\d{4})/,
                      "$1 $2 $3"
                    )
                  : tel.name
              }}</span>
              <div class="tel-handle">
                <a
                  href="javascript:void(0)"
                  class="delete"
                  @click="deleteTelEvent(tel.mobile, tel.name, telIndex)"
                >
                  {{ $t("common.delete") }}
                </a>
                <a
                  href="javascript:void(0)"
                  class="amend"
                  @click="amendTelEvent(tel.mobile, tel.name, telIndex)"
                >
                  {{ $t("common.edit") }}
                </a>
              </div>
            </div>
          </TabPane>
        </Tabs>
      </div>
    </div>
    <!-- 添加标签 -->
    <Modal
      v-model="tagFlag"
      :title="$t('recharge.addLabel')"
      class-name="vertical-center-modal"
      width="490"
      @on-cancel="cancelEvent('tag')"
      :mask-closable="false"
    >
      <div class="modal-container">
        <Input
          class="tel-input"
          v-model="curTag"
          :placeholder="$t('recharge.enterLabelName')"
        />
        <div class="tag-wrapper">
          <span
            :class="{ active: tagIndex == index }"
            v-for="(tag, index) in tagList"
            :key="index"
            @click="tagEvent(tag.tag_name, index)"
          >
            {{ tag.tag_name }}
          </span>
        </div>
      </div>
      <div slot="footer" align="center">
        <Button type="primary" @click="submitEvent('tag')">
          {{ $t("common.confirm") }}
        </Button>
      </div>
    </Modal>

    <!-- 修改号码 -->
    <Modal
      v-model="telFlag"
      :title="
        telType == 1 ? $t('recharge.editNumber') : $t('recharge.newNumber')
      "
      class-name="vertical-center-modal"
      width="490"
      @on-cancel="cancelEvent('tel')"
      :mask-closable="false"
    >
      <div class="modal-container">
        <Input
          class="tel-input"
          v-model="telName"
          :placeholder="$t('recharge.clickAddNote')"
        />
      </div>
      <div class="modal-container">
        <Input
          class="tel-input"
          v-model="telNumber"
          :maxlength="13"
          :placeholder="$t('common.enterMobile')"
        />
      </div>
      <div slot="footer" align="center">
        <Button type="primary" :loading="loading" @click="submitEvent('tel')">
          {{ $t("common.confirm") }}
        </Button>
      </div>
    </Modal>
    <!-- 标签管理 -->
    <Modal
      v-model="tagItemPop"
      footer-hide
      :title="$t('recharge.labelManagement')"
      class-name="vertical-center-modal"
      @on-cancel="cancelEvent('tag')"
      width="490"
      :mask-closable="false"
    >
      <div class="modal-container manage-container">
        <div class="add-tag">
          <h3>
            <span>{{ $t("recharge.addNewLabel") }}</span>
            <a @click="addTagSubmit">
              {{ $t("common.add") }}
            </a>
          </h3>
          <Input
            class="tel-input-add"
            v-model="curTag"
            :placeholder="$t('recharge.enterLabelName')"
          />
        </div>
        <div class="my-tag">
          <h3>
            <span>{{ $t("recharge.labelManagement") }}</span>
          </h3>
          <div class="tag-list">
            <div class="tag-item" v-for="(tag, index) in tagList" :key="index">
              <span>{{ tag.tag_name }}</span>
              <p>
                <a class="text-orange" @click="delTagItem(index)">
                  {{ $t("common.delete") }}
                </a>
                <a @click="editTagItem(index)">
                  {{ $t("common.edit") }}
                </a>
              </p>
            </div>
          </div>
        </div>
      </div>
      <!-- <div slot="footer" align="center"></div> -->
    </Modal>
    <!-- 编辑标签 -->
    <Modal
      v-model="editTagPop"
      :title="$t('common.delete')"
      class-name="vertical-center-modal"
      @on-cancel="cancelEvent('tag')"
      width="490"
      :mask-closable="false"
    >
      <div class="modal-container">
        <Input
          class="tel-input"
          v-model="curTag"
          :placeholder="$t('recharge.enterLabelName')"
        />
      </div>
      <div slot="footer" class="footer" align="center">
        <Button type="primary" :loading="editTagFlag" @click="editTagSubmit">
          {{ $t("common.save") }}
        </Button>
      </div>
    </Modal>
  </div>
</template>

<script>
export default {
  name: "recharge-phone",
  data() {
    return {
      tagList: [],
      telList: [],
      showList: [],
      selectTag: "", //当前选择标签
      selectIndex: 0, //选择标签索引

      tagFlag: false, //标签弹窗
      curTag: "", //当前标签
      tagIndex: null, //标签索引

      telFlag: false, //号码弹窗
      telType: 1, //号码弹窗标题，1为添加 2为修改
      telNumber: "", //号码数字
      telName: "", //号码备注
      telIndex: null, //修改号码索引

      collapseVal: "", //当前显示折叠
      phone: "",

      loading: false,

      tagItemPop: false,
      editTagPop: false, //编辑标签弹窗
      editTagFlag: false
    };
  },
  created() {
    let vm = this;
    vm._getMobileTags();
  },
  mounted() {},
  computed: {},
  methods: {
    addTagSubmit() {
      //添加标签
      let vm = this;
      if (vm.addTagFlag) {
        return;
      }
      if (vm.curTag == "") {
        vm.$Message.error(vm.$t("recharge.enterLabelName"));
        return false;
      }

      let reg = /^[\da-z\u4e00-\u9fa5]{2,4}$/i;
      if (!reg.test(vm.curTag)) {
        vm.$Message.error(vm.$t("recharge.enter2-4letterOrChinese"));
        return false;
      }
      let params = {};
      params.tag_name = vm.curTag;
      vm.addTagFlag = true;
      vm.$Spin.show();
      vm.$post("/app/user/userMobileTagsAdd", params, { alert: true }).then(
        res => {
          vm.$Spin.hide();
          if (res.code == 0) {
            vm.$Message.success({
              content: res.msg,
              onClose: function() {
                vm._getMobileTags();
                vm.curTag = "";
                vm.tagIndex = null;
                vm.addTagFlag = false;
              }
            });
          } else {
            vm.$Message.error({
              content: res.msg,
              onClose: function() {
                vm.curTag = "";
                vm.tagIndex = null;
                vm.addTagFlag = false;
              }
            });
          }
        }
      );
    },
    delTagItem(index) {
      //删除标签
      let vm = this;
      if (vm.delTagFlag) {
        return;
      }
      let params = {};
      params.tag = vm.tagList[index].id;
      vm.delTagFlag = true;
      vm.$Modal.confirm({
        title: vm.$t("recharge.sureLabelAndPhone"),
        onOk: () => {
          vm.$Spin.show();
          vm.$post("/app/user/delTags", params, {
            loading: true,
            alert: true
          }).then(res => {
            vm.$Spin.hide();
            if (res.code == 0) {
              vm.$Message.success({
                content: res.msg,
                onClose: function() {
                  vm.delTagFlag = false;
                  vm._getMobileTags();
                }
              });
            } else {
              vm.$Message.error({
                content: res.msg,
                onClose: function() {
                  vm.delTagFlag = false;
                }
              });
            }
          });
        }
      });
    },
    editTagItem(index) {
      //编辑标签
      let vm = this;
      vm.editTagPop = true;
      vm.tagIndex = index;
      vm.curTag = vm.tagList[vm.tagIndex].tag_name;
    },
    editTagSubmit() {
      // 编辑标签提交
      let vm = this;
      if (vm.editTagFlag) {
        return;
      }
      if (vm.curTag == "") {
        vm.$Message.error(vm.$t("recharge.enterLabelName"));
        return false;
      }

      let reg = /^[\da-z\u4e00-\u9fa5]{2,4}$/i;
      if (!reg.test(vm.curTag)) {
        vm.$Message.error(vm.$t("recharge.enter2-4letterOrChinese"));
        return false;
      }
      let params = {};
      params.tag_id = vm.tagList[vm.tagIndex].id;
      params.tag_name = vm.curTag;
      vm.editTagFlag = true;
      vm.$post("/app/user/userMobileTagsEdit", params, { alert: true }).then(
        res => {
          vm.editTagFlag = false;
          if (res.code == 0) {
            vm.$Message.success({
              content: res.msg,
              onClose: function() {
                vm.tagList[vm.tagIndex].tag_name = vm.curTag;
                vm.curTag = "";
                vm.tagIndex = null;
                vm.editTagPop = false;
              }
            });
          } else {
            vm.$Message.error({
              content: res.msg,
              onClose: function() {}
            });
          }
        }
      );
    },
    changeTab(data) {
      let vm = this;
      vm.telList = [];
      vm.showList = [];
      vm._getMobileList(data);
    },
    searchNum() {
      //搜索
      let vm = this;
      if (vm.phone == "") {
        // vm.$Message.info(vm.$t("common.enterMobile"));
        vm.showList = vm.telList;
        // vm._getMobileList(vm.selectIndex);
        return;
      }
      let tel = vm.phone.replace(/\s/g, "");
      let tel1 = vm.phone
        .replace(/\s/g, "")
        .replace(/(0?\d{4})(\d{3})(\d{4})/, "$1 $2 $3");
      let arr = [];
      for (let i = 0; i < vm.telList.length; i++) {
        if (
          vm.telList[i].mobile.indexOf(tel) != -1 ||
          vm.telList[i].mobile.indexOf(tel1) != -1
        ) {
          arr.push(vm.telList[i]);
        }
      }
      vm.showList = arr;
    },
    addBtnFun() {
      //新增号码
      let vm = this;
      //判断是否存在标签
      if (!vm.tagList.length) {
        vm.$Message.info(vm.$t("recharge.addLabelAfterNumber"));
        return false;
      }
      vm.telFlag = true;
      vm.telType = 2;
    },
    _getSelectTag(tag, index) {
      //选择标签获取号码
      let vm = this;
      vm.selectTag = tag;
      vm.selectIndex = index;
      vm._getMobileList(vm.selectIndex);
    },
    tagEvent(tag, index) {
      //修改添加标签
      let vm = this;
      // if (index == 0) {
      //   return
      // }
      vm.curTag = tag;
      vm.tagIndex = index;
    },
    deleteTelEvent(tel, name, index) {
      //删除号码
      let vm = this;
      vm.$Modal.confirm({
        title: vm.$t("recharge.sureDeleteNumber"),
        onOk: () => {
          let params = {};
          params.mobile_id = vm.telList[index].id;
          vm.$post("/app/user/userMobilesDelete", params, {
            alert: true,
            loading: true
          }).then(res => {
            if (res.code == 0) {
              vm.$Message.success({
                content: res.msg,
                onClose: function() {
                  let list = vm.telList;
                  for (let i = 0; i < list.length; i++) {
                    if (index == i) {
                      list.splice(i, 1);
                      break;
                    }
                  }
                  vm.telList = list;
                  vm.showList = list;
                  vm.collapseVal = "";
                }
              });
            } else {
              vm.$Message.error({
                content: res.msg,
                onClose: function() {}
              });
            }
          });
        }
      });
    },
    amendTelEvent(tel, name, index) {
      //修改号码
      let vm = this;
      vm.telFlag = true;
      vm.telType = 1;
      vm.telNumber = tel;
      vm.telName = name;
      vm.telIndex = index;
    },
    submitEvent(flag) {
      //提交事件
      let vm = this;
      if (flag == "tag") {
        if (vm.curTag == "") {
          vm.$Message.info(vm.$t("recharge.enterLabelName"));
          return;
        }
        if (vm.tagIndex != null) {
          //编辑
          if (vm.tagList[vm.tagIndex].tag_name == vm.curTag) {
            vm.$Message.info(vm.$t("recharge.modifyAndSubmit"));
            return false;
          }
          for (let i = 0; i < vm.tagList.length; i++) {
            if (vm.tagList[i].tag_name == vm.curTag) {
              vm.$Message.info(vm.$t("recharge.labelAlreadyExists"));
              return;
            }
          }
          vm.editTag();
        } else {
          //添加
          if (vm.tagList.length == 5) {
            vm.$Message.info(vm.$t("recharge.addLabelLimitTips"));
            return;
          }
          for (let i = 0; i < vm.tagList.length; i++) {
            if (vm.tagList[i].tag_name == vm.curTag) {
              vm.$Message.info(vm.$t("recharge.labelAlreadyExists"));
              return;
            }
          }
          vm.addTag();
        }
        // vm.cancelEvent(flag);
      }
      if (flag == "tel") {
        if (vm.telNumber == "") {
          vm.$Message.info(vm.$t("common.enterMobile"));
          return;
        }
        if (vm.telType == 1) {
          vm.editMobile();
        } else {
          vm.addMobile();
        }
      }
    },
    cancelEvent(flag) {
      //取消事件
      let vm = this;
      if (flag == "tag") {
        vm.curTag = "";
        vm.tagIndex = null;
      }
      if (flag == "tel") {
        vm.telFlag = false;
        vm.telNumber = "";
        vm.telName = "";
        vm.telIndex = null;
      }
    },
    editMobile() {
      //修改号码
      let vm = this;
      //先判断该标签中是否存在号码
      let index = -1;
      for (let i = 0; i < vm.telList.length; i++) {
        if (
          vm.telList[i].mobile.replace(/\s/g, "") ==
          vm.telNumber.replace(/\s/g, "")
        ) {
          index = i;
        }
      }
      if (index != -1) {
        //存在该号码，判断是否修改了备注
        if (vm.telName == vm.telList[index].name) {
          vm.$Message.info(vm.$t("recharge.mobileEditFailed"));
          return;
        }
      }
      //取当前修改号码的下标在vm.telList中的位置
      let thisIndex = -1;
      for (let i = 0; i < vm.telList.length; i++) {
        if (vm.showList[vm.telIndex].id == vm.telList[i].id) {
          thisIndex = i;
        }
      }
      let params = {};
      params.mobile = vm.telNumber.replace(/\s/g, "");
      params.name = vm.telName;
      params.mobile_id = vm.showList[vm.telIndex].id;
      vm.loading = true;
      vm.$post("/app/user/userMobilesEdit", params, { alert: true }).then(
        res => {
          vm.loading = false;
          vm.collapseVal = "";
          if (res.code == 0) {
            vm.$Message.success({
              content: res.msg,
              onClose: function() {
                vm.telList[thisIndex].mobile = vm.telNumber;
                vm.telList[thisIndex].name = vm.telName;
                vm.showList[vm.telIndex].mobile = vm.telNumber;
                vm.showList[vm.telIndex].name = vm.telName;
                vm.collapseVal = "";
                vm.telFlag = false;
                vm.telNumber = "";
                vm.telName = "";
                vm.telIndex = null;
                //修改完成之后执行一下搜索
                vm.searchNum();
              }
            });
          } else {
            vm.$Loading.error();
            vm.$Message.error({
              content: res.msg,
              onClose: function() {}
            });
          }
        }
      );
    },
    addMobile() {
      //添加号码
      let vm = this;
      //先判断该标签中是否存在号码
      let index = -1;
      for (let i = 0; i < vm.telList.length; i++) {
        if (
          vm.telList[i].mobile.replace(/\s/g, "") ==
          vm.telNumber.replace(/\s/g, "")
        ) {
          index = i;
        }
      }
      if (index != -1) {
        vm.$Message.info(vm.$t("recharge.labelAlreadyNumber"));
        return;
      }
      let params = {};
      params.tag = vm.tagList[vm.selectIndex].id;
      params.mobile = vm.telNumber.replace(/\s/g, "");
      params.name = vm.telName;
      vm.$Loading.start();
      vm.loading = true;
      vm.$post("/app/user/userMobilesAdd", params, { alert: true }).then(
        res => {
          vm.loading = false;
          if (res.code == 0) {
            vm.$Loading.finish();
            vm.$Message.success({
              content: res.msg,
              onClose: function() {
                vm.phone = "";
                vm.telFlag = false;
                vm.telNumber = "";
                vm.telName = "";
                vm._getMobileList(vm.selectIndex);
              }
            });
          } else {
            vm.$Loading.error();
            vm.$Message.error({
              content: res.msg,
              onClose: function() {}
            });
          }
        }
      );
    },
    editTag() {
      //编辑标签
      let vm = this;
      let params = {};
      params.tag_id = vm.tagList[vm.tagIndex].id;
      params.tag_name = vm.curTag;
      vm.$post("/app/user/userMobileTagsEdit", params, { alert: true }).then(
        res => {
          if (res.code == 0) {
            vm.tagList[vm.tagIndex].tag_name = vm.curTag;
            vm.tagFlag = false;
            vm.curTag = "";
            vm.tagIndex = null;
          } else {
            vm.$Message.error({
              content: res.msg,
              onClose: function() {}
            });
          }
        }
      );
    },
    addTag() {
      //添加标签
      let vm = this;
      let params = {};
      params.tag_name = vm.curTag;
      vm.$post("/app/user/userMobileTagsAdd", params, { alert: true }).then(
        res => {
          if (res.code == 0) {
            vm.$Message.success({
              content: res.msg,
              onClose: function() {
                vm._getMobileTags();
                vm.tagFlag = false;
                vm.curTag = "";
                vm.tagIndex = null;
              }
            });
          } else {
            vm.$Message.error({
              content: res.msg,
              onClose: function() {}
            });
          }
        }
      );
    },
    _getMobileTags() {
      //获取电话簿标签
      let vm = this;
      vm.$post("/app/user/userMobileTags", {}, { loading: true }).then(res => {
        console.log("userMobileTags", res);
        vm.tagList = res.list;
        if (vm.tagList.length) {
          vm.selectTag = vm.tagList[0].tag_name;
          vm.selectIndex = 0;
          vm._getMobileList(0);
        }
      });
    },
    _getMobileList(index) {
      //获取电话簿列表
      let vm = this;
      let params = {};
      params.tag = vm.tagList[index].id;
      vm.$post("/app/user/userMobiles", params).then(res => {
        vm.telList = res.list;
        vm.showList = res.list;
      });
    }
  },
  components: {},
  watch: {
    telNumber(val) {
      if (val) {
        this.telNumber = val
          .replace(/\s/g, "")
          .replace(/(0?\d{4})(\d{3})(\d{4})/, "$1 $2 $3");
      }
    }
  },
  beforeDestroy() {}
};
</script>
<style lang="less" scoped>
@imgUrl: "~@/assets/images/";
.phone-wrap {
  padding: 20px 50px;
}
.search-wrapper {
  display: flex;
  justify-content: flex-start;
  align-items: center;
  padding: 10px 0;
  /deep/.ivu-input {
    background: #eff2f5;
    border-color: #eff2f5;
    &:focus {
      box-shadow: none;
    }
  }
  button {
    margin-left: 10px;
  }
}
.tag-wrapper {
  font-size: 14px;
  position: relative;
  .tag-manage {
    position: absolute;
    right: 16px;
    top: 8px;
    z-index: 10;
  }
  .noData {
    text-align: center;
    font-size: 15px;
  }
  /deep/.ivu-tabs {
    .ivu-tabs-nav .ivu-tabs-tab-active {
      color: #2042ab;
    }
    .ivu-tabs-ink-bar {
      background-color: #2042ab;
    }
  }
  .tel-info {
    height: 55px;
    display: flex;
    align-items: center;
    justify-content: space-between;
    padding: 0 15px;
    border-bottom: 1px solid #cccccc;
    .tel-name {
      color: #333333;
    }
    .tel-handle {
      display: flex;
      align-items: center;
      justify-content: space-between;
      a {
        margin-left: 20px;
        &.delete {
          color: #fe7800;
        }
      }
    }
  }
}
.tel-input-add {
  /deep/.ivu-input {
    padding: 0;
    height: 40px;
    font-size: 16px;
    border-radius: 0;
    border-width: 0 0 1px 0;
    &:focus {
      box-shadow: none;
    }
  }
  &.onlyread {
    /deep/.ivu-input-prefix i {
      line-height: 40px;
      color: #2042ab;
    }
    /deep/.ivu-input {
      padding-left: 30px;
      color: #2042ab;
      cursor: pointer;
    }
  }
}
.vertical-center-modal .ivu-modal .modal-container.manage-container {
  padding-top: 0;
}
.add-tag,
.my-tag {
  margin-bottom: 10px;
  h3 {
    display: flex;
    align-items: center;
    justify-content: space-between;
    span {
      font-size: 16px;
    }
    a {
      font-size: 14px;
    }
  }
}
.my-tag {
  margin-top: 16px;
}
.chooseTag-title {
  span {
    font-size: 18px;
  }
  a {
    font-size: 14px;
  }
}
.tag-list {
  h3 {
    display: flex;
    align-items: center;
    justify-content: space-between;
    span {
      font-size: 16px;
    }
  }
  .tag-item {
    height: 40px;
    border-bottom: 1px solid #ccc;
    display: flex;
    align-items: center;
    justify-content: space-between;
    font-size: 16px;
    p {
      margin-bottom: 0;
    }
    a {
      margin-left: 15px;
      font-size: 14px;
    }
  }
}
</style>
